var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplainUserIconAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99988 11C13.0393 11 15.5026 8.53789 15.5026 5.5C15.5026 2.46211 13.0393 0 9.99988 0C6.96048 0 4.49716 2.46211 4.49716 5.5C4.49716 8.53789 6.96048 11 9.99988 11ZM13.8518 12.375H13.1338C12.1795 12.8133 11.1176 13.0625 9.99988 13.0625C8.88214 13.0625 7.82458 12.8133 6.86591 12.375H6.14797C2.95811 12.375 0.370117 14.9617 0.370117 18.15V19.9375C0.370117 21.0762 1.2944 22 2.43364 22H17.5661C18.7053 22 19.6296 21.0762 19.6296 19.9375V18.15C19.6296 14.9617 17.0416 12.375 13.8518 12.375Z",
    fill: "#F7FAFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.370117,
    width: 19.2595,
    height: 22,
    fill: "#F7FAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplainUserIconAlt);
export default __webpack_public_path__ + "static/media/explain-user-icon-alt.fdbc2076f9528c43ee9836687c970df2.svg";
export { ForwardRef as ReactComponent };